import { Injectable } from '@angular/core';
import { BaseGraphqlService } from '../graphQL.service';
import { environment } from '../../../../environments/environment';
import { Observable, map } from 'rxjs';
import { GET_ADMIN_USERS, GET_ADMIN_USERS_FILTER, GET_ROLES } from '../../querys/user/user-info.graphql';
import { CREATE_USER, DELETE_USER, DOWNLOAD_USER, GET_FORM_BYMODULEID, GET_STORE_CONFIG, UPDATE_USER } from '../../mutations/user/user.mutations';
import { ResponseFormsContractGraphQL } from '../../models/config/configContract.model';
import { UUID } from 'crypto';

@Injectable()
export class UserGraphQLService {

  private graphqlUrl!:string;
  private graphqlGeneralUrl!:string;
  storeConfig: any;
  typeUser: number = 1;
  lang:string='es';
  public userInfo!: any | null;
  constructor(private _graphqlService: BaseGraphqlService) {
    this.graphqlUrl = environment.urlsGraphQL.urlGraphQLAccounts;
    this.graphqlGeneralUrl =  environment.urlsGraphQL.urlGraphQLGeneral
    this.lang=localStorage.getItem('languageTemplateIdentifier')?.toLowerCase() || 'es';
  }



  public createUser(
    input: any
  ): Observable<string> {
    var variable = { input: input, lang: this.lang };
    return this._graphqlService.mutation<string, any>(
      CREATE_USER,
      this.graphqlUrl,
      variable
    );
  }


  public getStoreConfig(
    input: any
  ): Observable<any> {
    var variable = { input: input };
    return this._graphqlService.mutation<any, any>(
      GET_STORE_CONFIG,
      this.graphqlUrl,
      variable
    );
  }

    /**
   * Retrieves a form configuration by its module ID and store ID.
   *
   * @param moduleId - The ID of the module associated with the form.
   * @param storeId - The ID of the store associated with the form.
   * @returns An observable that emits the form configuration as a `ResponseFormsContractGraphQL` object.
   *
   * @remarks
   * This function uses the `GET_FORM_BYMODULEID` GraphQL query to fetch the form configuration based on the provided module ID and store ID.
   * It also sets the current language for the form based on the current language set in the `TranslateService`.
   * The function then constructs a variable object with the module ID, store ID, and language, and passes it to the `queryFilter` method of the `_graphqlService`.
   * The `queryFilter` method sends the GraphQL query to the specified GraphQL endpoint and returns the response as an observable.
   */
  public getFormByModuleId(moduleId: any, storeId:any): Observable<ResponseFormsContractGraphQL> {

    var variable = { "moduleId": moduleId, "storeId": storeId, "lang": "es" };
    return this._graphqlService.queryFilter<ResponseFormsContractGraphQL, any>(
      GET_FORM_BYMODULEID,
      this.graphqlGeneralUrl,
      variable
    );
  }

}
